import { TOOL_NAMES } from 'js/src/agent/toolNames';
import { z } from 'zod';

import type { EnhancedToolResult } from '../../types';
import { Tool } from '../Tool';

import { getAllBrandKits } from 'js/src/data/brand-kits/brand-kits-selectors';

export const listBrandKitsSchema = z.object({});
export type ListBrandKitsArgs = z.infer<typeof listBrandKitsSchema>;

export class ListBrandKitsTool extends Tool<typeof listBrandKitsSchema> {
    protected override readonly schema = listBrandKitsSchema;
    protected override readonly toolName = TOOL_NAMES.listBrandKits;
    protected override readonly toolDescription =
        "List all of the current team's saved brand kits.";

    public override getToolDisplayName(): string {
        return 'Listing brand kits';
    }

    public get statusIcon(): string {
        return 'palette';
    }

    public override async execute(): Promise<EnhancedToolResult> {
        const brandKits = getAllBrandKits(this.getState()).toJS();
        return {
            result: JSON.stringify(brandKits),
            isSuccess: true,
        };
    }
}
